<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
                  <a-form-model-item prop="orderNo" v-if="formType === 2">
                        <span slot="label" ><a-tooltip>订单编号<template slot="title">订单编号</template></a-tooltip> </span>
                        <a-input v-model="form.orderNo" :maxLength="64" :placeholder="$t('通用.输入.请输入')+'订单编号'" />
                  </a-form-model-item>
                  <a-form-model-item prop="publisherId" >
                        <span slot="label" ><a-tooltip>发布人用户ID<template slot="title">发布人用户ID</template></a-tooltip> </span>
                        <a-input v-model="form.publisherId"  :placeholder="$t('通用.输入.请输入')+'发布人用户ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="receiverId" >
                        <span slot="label" ><a-tooltip>接单人用户ID<template slot="title">接单人用户ID</template></a-tooltip> </span>
                        <a-input v-model="form.receiverId"  :placeholder="$t('通用.输入.请输入')+'接单人用户ID'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskTitle" >
                        <span slot="label" ><a-tooltip>任务标题快照<template slot="title">任务标题快照</template></a-tooltip> </span>
                        <a-input v-model="form.taskTitle" :maxLength="100" :placeholder="$t('通用.输入.请输入')+'任务标题快照'" />
                  </a-form-model-item>
                  <a-form-model-item prop="taskDesc" >
                        <span slot="label" ><a-tooltip>任务描述快照<template slot="title">任务描述快照</template></a-tooltip> </span>
                        <a-input v-model="form.taskDesc" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="orderAmount" >
                        <span slot="label" ><a-tooltip>订单金额<template slot="title">订单金额</template></a-tooltip> </span>
                        <a-input v-model="form.orderAmount"  :placeholder="$t('通用.输入.请输入')+'订单金额'" />
                  </a-form-model-item>
                  <a-form-model-item prop="serviceCount" >
                        <span slot="label" ><a-tooltip>服务数量<template slot="title">服务数量</template></a-tooltip> </span>
                        <a-input v-model="form.serviceCount"  :placeholder="$t('通用.输入.请输入')+'服务数量'" />
                  </a-form-model-item>
                  <a-form-model-item prop="priceUnit" >
                        <span slot="label" ><a-tooltip>价格单位<template slot="title">价格单位</template></a-tooltip> </span>
                        <a-input v-model="form.priceUnit" :maxLength="20" :placeholder="$t('通用.输入.请输入')+'价格单位'" />
                  </a-form-model-item>
                  <a-form-model-item prop="isAppointment" >
                        <span slot="label" ><a-tooltip>是否预约单 0否 1是<template slot="title">是否预约单 0否 1是</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="appointmentTime" >
                        <span slot="label" ><a-tooltip>预约时间<template slot="title">预约时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.appointmentTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="province" >
                        <span slot="label" ><a-tooltip>省<template slot="title">省</template></a-tooltip> </span>
                        <a-input v-model="form.province" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'省'" />
                  </a-form-model-item>
                  <a-form-model-item prop="city" >
                        <span slot="label" ><a-tooltip>市<template slot="title">市</template></a-tooltip> </span>
                        <a-input v-model="form.city" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'市'" />
                  </a-form-model-item>
                  <a-form-model-item prop="district" >
                        <span slot="label" ><a-tooltip>区<template slot="title">区</template></a-tooltip> </span>
                        <a-input v-model="form.district" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'区'" />
                  </a-form-model-item>
                  <a-form-model-item prop="detailAddress" >
                        <span slot="label" ><a-tooltip>详细地址<template slot="title">详细地址</template></a-tooltip> </span>
                        <a-input v-model="form.detailAddress" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'详细地址'" />
                  </a-form-model-item>
                  <a-form-model-item prop="contactName" >
                        <span slot="label" ><a-tooltip>联系人<template slot="title">联系人</template></a-tooltip> </span>
                        <a-input v-model="form.contactName" :maxLength="50" :placeholder="$t('通用.输入.请输入')+'联系人'" />
                  </a-form-model-item>
                  <a-form-model-item prop="contactPhone" >
                        <span slot="label" ><a-tooltip>联系电话<template slot="title">联系电话</template></a-tooltip> </span>
                        <a-input v-model="form.contactPhone" :maxLength="30" :placeholder="$t('通用.输入.请输入')+'联系电话'" />
                  </a-form-model-item>
                  <a-form-model-item prop="orderStatus" >
                        <span slot="label" ><a-tooltip>        0待支付        1待服务        2服务中        3待确认        4已完成        5已取消        6退款中        7已退款        <template slot="title">        0待支付        1待服务        2服务中        3待确认        4已完成        5已取消        6退款中        7已退款        </template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="payStatus" >
                        <span slot="label" ><a-tooltip>支付状态 0未支付 1已支付 2已退款<template slot="title">支付状态 0未支付 1已支付 2已退款</template></a-tooltip> </span>
                  </a-form-model-item>
                  <a-form-model-item prop="payTime" >
                        <span slot="label" ><a-tooltip>支付时间<template slot="title">支付时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.payTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="receiveTime" >
                        <span slot="label" ><a-tooltip>接单时间<template slot="title">接单时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.receiveTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="finishTime" >
                        <span slot="label" ><a-tooltip>完成时间<template slot="title">完成时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.finishTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="cancelTime" >
                        <span slot="label" ><a-tooltip>取消时间<template slot="title">取消时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.cancelTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="cancelReason" >
                        <span slot="label" ><a-tooltip>取消原因<template slot="title">取消原因</template></a-tooltip> </span>
                        <a-input v-model="form.cancelReason" :maxLength="255" :placeholder="$t('通用.输入.请输入')+'取消原因'" />
                  </a-form-model-item>
                  <a-form-model-item prop="remark" >
                        <span slot="label" ><a-tooltip>备注<template slot="title">备注</template></a-tooltip> </span>
                        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
                  </a-form-model-item>
                  <a-form-model-item prop="createdAt" >
                        <span slot="label" ><a-tooltip>创建时间<template slot="title">创建时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.createdAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
                  <a-form-model-item prop="updatedAt" >
                        <span slot="label" ><a-tooltip>更新时间<template slot="title">更新时间</template></a-tooltip> </span>
                        <a-date-picker style="width: 100%" v-model="form.updatedAt" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
                  </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getTaskOrder, addTaskOrder, updateTaskOrder } from '@/api/task/taskOrder'
  import {mapGetters} from 'vuex'
  import CustomDictTag from "@/components/DictCustomTag";
  import {generateFilePath, uploadObject} from "@/api/tool/oss";


  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
                          orderNo: null,
                          publisherId: null,
                          receiverId: null,
                          taskTitle: null,
                          taskDesc: null,
                          orderAmount: null,
                          serviceCount: null,
                          priceUnit: null,
                      isAppointment: '0',
                          appointmentTime: null,
                          province: null,
                          city: null,
                          district: null,
                          detailAddress: null,
                          contactName: null,
                          contactPhone: null,
                          orderStatus: null,
                          payStatus: null,
                          payTime: null,
                          receiveTime: null,
                          finishTime: null,
                          cancelTime: null,
                          cancelReason: null,
                          remark: null,
                          createdAt: null,
                          updatedAt: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
                              orderNo: [{ required: true, message: '订单编号'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              publisherId: [{ required: true, message: '发布人用户ID'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              receiverId: [{ required: true, message: '接单人用户ID'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] ,
                              orderAmount: [{ required: true, message: '订单金额'+this.$t('通用.文本.不能为空'), trigger: 'blur' }] 
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
                          orderNo: null,
                          publisherId: null,
                          receiverId: null,
                          taskTitle: null,
                          taskDesc: null,
                          orderAmount: null,
                          serviceCount: null,
                          priceUnit: null,
                      isAppointment: '0',
                          appointmentTime: null,
                          province: null,
                          city: null,
                          district: null,
                          detailAddress: null,
                          contactName: null,
                          contactPhone: null,
                          orderStatus: null,
                          payStatus: null,
                          payTime: null,
                          receiveTime: null,
                          finishTime: null,
                          cancelTime: null,
                          cancelReason: null,
                          remark: null,
                          createdAt: null,
                          updatedAt: null,
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getTaskOrder({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateTaskOrder(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addTaskOrder(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message,3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
